import { Box, Button, styled } from '@mui/material';

import type { ButtonVariant } from './Toast';

export interface ToastContainerProps {
  backgroundColor?: string;
}

export const NOTIFICATION_HEIGHT = 44;
export const NOTIFICATION_GAP = 20;

export const NotificationsContainer = styled(Box)(() => ({
  position: 'fixed',
  zIndex: 9999,
  display: 'flex',
  left: 0,
  right: 0,
  bottom: '3.5rem',
  flexDirection: 'column',
  alignItems: 'center',
  pointerEvents: 'none',
}));

export const ToastContainer = styled(Box)<ToastContainerProps>(({ theme, backgroundColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: 'auto',
  padding: '5px 20px',
  minHeight: '2rem',
  textAlign: 'center',
  fontSize: '0.7rem',
  backgroundColor: backgroundColor || theme.palette.primary.main,
  pointerEvents: 'all',
  lineHeight: NOTIFICATION_HEIGHT,
  borderRadius: 10,
  maxWidth: '90vw',
  letterSpacing: '0.001rem',

  a: {
    color: 'white',
    textDecoration: 'underline',
  },
}));

export const NotificationButton = styled(Button)<{ buttonVariant?: ButtonVariant }>(
  ({ theme, buttonVariant = 'filled' }) => {
    const isOutlined = buttonVariant === 'outlined';

    return {
      ...theme.typography.body1,
      backgroundColor: isOutlined ? 'transparent' : 'white',
      color: isOutlined ? 'white' : theme.palette.primary.main,
      border: '1px solid white',
      borderRadius: theme.shape.borderRadiusSm,
      padding: theme.spacing(0.75, 1.5),
      whiteSpace: 'nowrap',
      transition: 'all .2s ease',

      '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: isOutlined ? 'white' : theme.palette.text.disabled,
        borderColor: isOutlined ? 'white' : theme.palette.text.disabled,
      },
    };
  },
);
